export default __webpack_public_path__ + "static/media/BG_00224.c2dc9ec8.jpg";